define('OutSystems/ReactView/CheckPermissionsNavigationCallbacks',["require", "exports", "tslib", "OutSystems/ClientRuntime/ErrorHandling", "OutSystems/ClientRuntime/Navigation", "./BaseNavigationCallbacks"], function (require, exports, tslib_1, ErrorHandling_1, Navigation_1, BaseNavigationCallbacks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CheckPermissionsNavigationCallbacks = (function (_super) {
        tslib_1.__extends(CheckPermissionsNavigationCallbacks, _super);
        function CheckPermissionsNavigationCallbacks(history, runtime, isFirstNavigation) {
            var _this = _super.call(this, history, runtime) || this;
            _this.isFirstNavigation = isFirstNavigation;
            _this.navigated = false;
            return _this;
        }
        CheckPermissionsNavigationCallbacks.prototype.goTo = function (urlInfo, transition, replace) {
            this.navigated = true;
            var location = BaseNavigationCallbacks_1.default.urlToLocationDescriptor(urlInfo, transition);
            this.replace(location);
        };
        CheckPermissionsNavigationCallbacks.prototype.navigateToInternalError = function (callContext) {
            (0, ErrorHandling_1.handleError)(new Error("No Permissions"), callContext);
        };
        CheckPermissionsNavigationCallbacks.prototype.goBack = function (transition) {
            this.navigated = true;
            if (this.isFirstNavigation()) {
                this.navigateToInternalError();
            }
            else {
                _super.prototype.goBack.call(this, transition);
            }
        };
        CheckPermissionsNavigationCallbacks.prototype.goForward = function (transition) {
            this.navigated = true;
            if (this.isFirstNavigation()) {
                this.navigateToInternalError();
            }
            else {
                _super.prototype.goForward.call(this, transition);
            }
        };
        CheckPermissionsNavigationCallbacks.prototype.dispose = function (callContext) {
            if (this.navigated || (0, Navigation_1.hasPendingReload)()) {
                return;
            }
            if (this.isFirstNavigation()) {
                this.navigateToInternalError(callContext);
            }
            else {
                _super.prototype.goBack.call(this);
            }
        };
        return CheckPermissionsNavigationCallbacks;
    }(BaseNavigationCallbacks_1.default));
    exports.default = CheckPermissionsNavigationCallbacks;
});
//# sourceMappingURL=CheckPermissionsNavigationCallbacks.js.map;
